
import { mapState, mapMutations } from 'vuex';
import Block from '@/components/ui/block';

export default {
  name: 'Page',

  components: {
    Block,
  },

  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(['couponCode']),

    blocks() {
      return this.page && this.page.acf ? this.page.acf.blocks : [];
    },

    blocksSliced() {
      return this.blocks?.length > 1 ? [...this.blocks].slice(2) : [];
    },

    content() {
      return this.page && this.page.content ? this.page.content.rendered : null;
    },

    isCampaign() {
      return this.page?.acf?.page_type === 'campaign';
    },

    isFullWidth() {
      return Boolean(this.page?.acf?.campaign_is_full_width);
    },

    campaignBg() {
      return this.page?.acf?.campaign_background || '';
    },

    campaignTextColor() {
      return this.page?.acf?.campaign_text_color || '';
    },

    campaignLogoStyle() {
      return this.page?.acf?.campaign_logo_style || '';
    },

    campaignCouponCode() {
      return this.page?.acf?.campaign_coupon_code || '';
    },

    campaignDisableGtm() {
      return Boolean(this.page?.acf?.campaign_disable_gtm);
    },

    campaignGtmId() {
      return this.page?.acf?.campaign_gtm_id || '';
    },

    isFirstBlockHeroAlt() {
      return (
        this.blocks &&
        this.blocks.length > 0 &&
        this.blocks[0].acf_fc_layout === 'heroAlt'
      );
    },
  },

  mounted() {
    this.getCouponCode();

    if (this.isCampaign) {
      this.$store.commit('setGtmOverride', {
        disabled: Boolean(this.page?.acf?.campaign_disable_gtm),
        id: this.page?.acf?.campaign_gtm_id || null,
      });
    } else {
      this.$store.commit('clearGtmOverride');
    }
  },

  beforeDestroy() {
    this.$store.commit('clearGtmOverride');
  },

  methods: {
    ...mapMutations(['setCouponCode']),

    getCouponCode() {
      if (!this.isCampaign) return;
      const code = this.campaignCouponCode || '';
      if (!code) return;
      this.setCouponCode(code);
    },
  },

  head() {
    const bodyClasses = [];
    if (this.isCampaign && this.isFullWidth) {
      bodyClasses.push('page_campaign--full-width');
    } else if (this.isCampaign) {
      bodyClasses.push('page_campaign');
    }
    if (this.campaignLogoStyle) {
      bodyClasses.push('logo-' + this.campaignLogoStyle);
    }
    const meta = [];

    if (this.campaignBg) {
      const color = this.campaignBg.startsWith('#')
        ? this.campaignBg
        : `#${this.campaignBg}`;
      meta.push({
        hid: 'theme-color-light',
        name: 'theme-color',
        content: color,
        media: '(prefers-color-scheme: light)',
      });
      meta.push({
        hid: 'theme-color-dark',
        name: 'theme-color',
        content: color,
        media: '(prefers-color-scheme: dark)',
      });
    }

    return {
      bodyAttrs: {
        class: bodyClasses.join(' '),
        style: this.campaignBg ? `background: ${this.campaignBg};` : '',
      },
      meta,
    };
  },
};
